// extracted by mini-css-extract-plugin
module.exports = {"footer":"MobileScreen_footer__JO5_Q"};